import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../config.js";
import "./has.js";
import { isSome as t } from "./maybe.js";
import { numericHash as r } from "./string.js";
var o = {
  info: 0,
  warn: 1,
  error: 2,
  none: 3
};

var s = /*#__PURE__*/function () {
  function s(e) {
    _classCallCheck(this, s);

    this.level = null, this._module = "", this._parent = null, this.writer = null, this._loggedMessages = {
      error: new Map(),
      warn: new Map(),
      info: new Map()
    }, null != e.level && (this.level = e.level), null != e.writer && (this.writer = e.writer), this._module = e.module, s._loggers[this.module] = this;
    var t = this.module.lastIndexOf(".");
    -1 !== t && (this._parent = s.getLogger(this.module.slice(0, t)));
  }

  _createClass(s, [{
    key: "module",
    get: function get() {
      return this._module;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      this._log.apply(this, ["error", "always"].concat(e));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }

      this._log.apply(this, ["warn", "always"].concat(e));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }

      this._log.apply(this, ["info", "always"].concat(e));
    }
  }, {
    key: "errorOnce",
    value: function errorOnce() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      this._log.apply(this, ["error", "once"].concat(e));
    }
  }, {
    key: "warnOnce",
    value: function warnOnce() {
      for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        e[_key5] = arguments[_key5];
      }

      this._log.apply(this, ["warn", "once"].concat(e));
    }
  }, {
    key: "infoOnce",
    value: function infoOnce() {
      for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        e[_key6] = arguments[_key6];
      }

      this._log.apply(this, ["info", "once"].concat(e));
    }
  }, {
    key: "errorOncePerTick",
    value: function errorOncePerTick() {
      for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        e[_key7] = arguments[_key7];
      }

      this._log.apply(this, ["error", "oncePerTick"].concat(e));
    }
  }, {
    key: "warnOncePerTick",
    value: function warnOncePerTick() {
      for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        e[_key8] = arguments[_key8];
      }

      this._log.apply(this, ["warn", "oncePerTick"].concat(e));
    }
  }, {
    key: "infoOncePerTick",
    value: function infoOncePerTick() {
      for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        e[_key9] = arguments[_key9];
      }

      this._log.apply(this, ["info", "oncePerTick"].concat(e));
    }
  }, {
    key: "test",
    get: function get() {
      var e = this;
      return {
        loggedMessages: e._loggedMessages,
        clearLoggedWarnings: function clearLoggedWarnings() {
          return e._loggedMessages.warn.clear();
        }
      };
    }
  }, {
    key: "_log",
    value: function _log(t, r) {
      if (!this._matchLevel(t)) return;

      for (var _len10 = arguments.length, o = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        o[_key10 - 2] = arguments[_key10];
      }

      if ("always" !== r && !s._throttlingDisabled) {
        var _e = this._argsToKey(o),
            n = this._loggedMessages[t].get(_e);

        if ("once" === r && null != n || "oncePerTick" === r && n && n >= s._tickCounter) return;
        this._loggedMessages[t].set(_e, s._tickCounter), s._scheduleTickCounterIncrement();
      }

      var _iterator = _createForOfIteratorHelper(e.log.interceptors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s2 = _step.value;
          if (_s2.apply(void 0, [t, this.module].concat(o))) return;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._inheritedWriter().apply(void 0, [t, this.module].concat(o));
    }
  }, {
    key: "_parentWithMember",
    value: function _parentWithMember(e, r) {
      var o = this;

      for (; t(o);) {
        var _r = o[e];
        if (t(_r)) return _r;
        o = o.parent;
      }

      return r;
    }
  }, {
    key: "_inheritedWriter",
    value: function _inheritedWriter() {
      return this._parentWithMember("writer", this._consoleWriter);
    }
  }, {
    key: "_consoleWriter",
    value: function _consoleWriter(e, t) {
      var _console;

      for (var _len11 = arguments.length, r = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        r[_key11 - 2] = arguments[_key11];
      }

      (_console = console)[e].apply(_console, ["[".concat(t, "]")].concat(r));
    }
  }, {
    key: "_matchLevel",
    value: function _matchLevel(t) {
      var r = e.log.level ? e.log.level : "warn";
      return o[this._parentWithMember("level", r)] <= o[t];
    }
  }, {
    key: "_argsToKey",
    value: function _argsToKey() {
      var t = function t(e, _t) {
        return "object" != typeof _t || Array.isArray(_t) ? _t : "[Object]";
      };

      for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        e[_key12] = arguments[_key12];
      }

      return r(JSON.stringify(e, t));
    }
  }], [{
    key: "testSingleton",
    get: function get() {
      return {
        resetLoggers: function resetLoggers() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = s._loggers;
          return s._loggers = e, t;
        },

        set throttlingDisabled(e) {
          s._throttlingDisabled = e;
        }

      };
    }
  }, {
    key: "getLogger",
    value: function getLogger(e) {
      var t = s._loggers[e];
      return t || (t = new s({
        module: e
      })), t;
    }
  }, {
    key: "_scheduleTickCounterIncrement",
    value: function _scheduleTickCounterIncrement() {
      s._tickCounterScheduled || (s._tickCounterScheduled = !0, Promise.resolve().then(function () {
        s._tickCounter++, s._tickCounterScheduled = !1;
      }));
    }
  }]);

  return s;
}();

s._loggers = {}, s._tickCounter = 0, s._tickCounterScheduled = !1, s._throttlingDisabled = !1;
export { s as default };